import React, { useState, useContext } from "react";
import { useTranslation } from "react-i18next";

import Button from "shared/components/FormElements/Button";
import CustomSelect from "shared/components/FormElements/Select";
import Modal from "shared/components/UIElements/Modal";

import ParentItem from "features/users/parent/ParentItem";

import { useForm } from "shared/hooks/form-hook";
import { StoreContext } from "shared/context/store-context";

const AddParentButton = ({ onAddPresentParent, onAddNewParent }) => {
  const { t } = useTranslation();

  const { parentOptions, InsertUser } = useContext(StoreContext);
  const [showParentModal, setShowParentModal] = useState(false);
  const [showCreateForm, setShowCreateForm] = useState(false);

  const [formState, inputHandler] = useForm(
    {
      //inputs
      parent: { value: null, isValid: true },
    },
    true
  );

  return (
    <div className="horizontal-flex" style={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
      <Button
        type="button"
        size="small"
        containerStyle={{ display: "flex", justifyContent: "flex-end" }}
        onClick={() => {
          setShowParentModal(true);
          setShowCreateForm(false);
        }}
      >
        ➕ {t("addNewParent")}
      </Button>
      <Modal
        show={showParentModal}
        style={{ paddingBottom: "20px", minHeight: showCreateForm ? "auto" : "280px" }}
        contentClass="overview-visible"
        onCancel={() => {
          setShowParentModal(false);
          setShowCreateForm(false);
        }}
        header={t("addNewParent")}
      >
        <div>
          <CustomSelect
            options={parentOptions}
            id="parent"
            onInput={inputHandler}
            label={t("selectParent")}
            initialValue={parentOptions.find((option) => option.value === formState.inputs.parent.value)}
            initialValid={true}
          ></CustomSelect>

          <Button
            type="button"
            containerStyle={{ display: "flex", justifyContent: "flex-end" }}
            onClick={() => {
              if (!formState.inputs.parent.value) {
                return;
              }
              onAddPresentParent(formState.inputs.parent.value);
              setShowCreateForm(false);
              setShowParentModal(false);
            }}
            disabled={!formState.inputs.parent.value}
          >
            {t("add")}
          </Button>
          <div>
            <div
              style={{ marginTop: "20px", borderBottom: "1px solid var(--color-button-primary-disabled-background)" }}
            ></div>
            <div style={{ marginTop: "20px", marginBottom: "10px", fontSize: "14px" }}>
              <span
                style={{
                  cursor: "pointer",
                  color: "var(--color-button-primary-background)",
                  textDecoration: "underline",
                }}
                onClick={() => setShowCreateForm((prev) => !prev)}
              >
                {t("ifNoParentUseForm")}
              </span>
            </div>
            {showCreateForm && (
              <>
                <div style={{ marginTop: "20px" }} />
                <ParentItem
                  isNewItem={true}
                  inModal={true}
                  InsertItem={InsertUser}
                  onClose={() => setShowCreateForm(false)}
                  onCreated={(parent) => {
                    onAddNewParent(parent);
                    setShowParentModal(false);
                    setShowCreateForm(false);
                  }}
                />
              </>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AddParentButton;
